export default __webpack_public_path__ + "static/media/arrowright.cdc12ed2.svg";